import { defineStore } from 'pinia';
import SearchUtils from '../utility/searchUtils';

export const useSearch = defineStore('search', {
  state: () => ({
    simpleSearch: [],

    simpleSearchKeys: [],
  
    freeTextSearch: {
      text: ""
    },
  
    advancedSearch: [
      {
        "key": "",
        "operator": "=",
        "value": "",
        "dataType": ""
      }
    ],
  
    pagination: {
      page: 1,
      limit: 10,
      pageOptions: [10, 25, 50, 100]
    },
  
    searchMode: 'simple',
  
    states: {
      searching: false,
      deleting: false,
      hasError: false,
      showSuccess: false,
    },
  
    items: [],
  
    operators: ["=", "!=", ">", "<", ">=", "<=", "like", "not like", "in", "not in"],
  
    specialOperators: ["like", "not like", "in", "not in"],
  
    dataTypes: [
      { value: "", text: 'String' },
      { value: "boolean", text: 'Boolean' },
      { value: "float", text: 'Number' },
    ],
  
    activeFilter: {
      status: "all",
    },
  
    errorMessage: null,
  }),
  getters: {
    getActiveFilter() {
      switch (String(this.activeFilter.status)) {
        case '':
        case 'all':
          return '';
        case 'active':
          return ",isActive(boolean)=true";
        case 'inactive':
          return ",isActive(boolean)=false";
        default:
          return `,attributes.status=${this.activeFilter.status}`
      }
    },
    searchCriteria() {
      let searchText = '';
  
      if (this.searchMode == 'simple') {
        searchText = SearchUtils.buildFromSimpleSearch(
          this.simpleSearch, this.simpleSearchKeys);
      } else if (this.searchMode == 'freetext') {
        searchText = this.freeTextSearch.text;
      } else {
        searchText = SearchUtils.buildFromAdvancedSearch(
          this.advancedSearch, this.specialOperators);
      }
  
      return searchText;
    },
    getSimpleSearch() {
      return this.simpleSearch
    },
    getSearchMode() {
        return this.searchMode;
    }
  },
  actions: {
    updateStates(payload) {
      _.merge(this.states, payload);
    },
    setItems(items) {
      this.items = items;
    },
    setSimpleSearchKeys(items) {
      this.simpleSearchKeys = items;
      this.simpleSearch = Array(items.length);
    },
    setErrorMessage(errorMessage) {
      this.errorMessage = errorMessage;
    },
    setPage(page) {
      this.pagination.page = page;
  
      // Trigger Search
      this.states.searching = true;
    },
    setLimit(limit) {
      this.pagination.limit = limit;
      this.pagination.page = 1;
  
      // Trigger Search
      this.states.searching = true;
    },
    setFreeTextSearch(text) {
      this.freeTextSearch.text = text;
    },
    setAdvancedSearch(text) {
      if (text)
        this.advancedSearch = SearchUtils.parseAdvancedSearchFromString(
          text,
          this.operators,
          this.specialOperators
        );
    },
    updateSimpleSearchValue(payload) {
      this.simpleSearch[payload.key] = payload.value;
    },
    setSearchMode(val) {
      this.searchMode = val;
    },
    resetSearch() {
      this.simpleSearch = this.simpleSearch.map(i => '');
      this.simpleSearch.active = null;
      this.advancedSearch = [];
  
      // Trigger Search
      this.states.searching = true;
    },
    addNewCriteria() {
      this.advancedSearch.push({
        "key": "",
        "operator": "=",
        "value": "",
        "dataType": ""
      });
    },
    updateSearchCriteria(payload) {
      let data = this.advancedSearch[payload.index];
      _.merge(data, payload.data);
      this.advancedSearch[payload.index] = data;
    },
    deleteCriteria(index) {
      this.advancedSearch.splice(index, 1);
    },
    buildSearchCriteria() {
      this.simpleSearch.text = SearchUtils.buildSimpleSearch(
        this.advancedSearch, this.specialOperators);
    },
    updateActiveFilter(payload) {
      this.activeFilter.status = payload;
    }
  }
})
